import { CSSProperties } from "@material-ui/core/styles/withStyles";
import { greys, palette, colors } from "@clockwise/web-commons/src/styles/color.styles";
import * as typeStyles from "@clockwise/web-commons/src/styles/type.styles";

export const item: CSSProperties = {
  padding: "10px 2px",
};

export const row: CSSProperties = {
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
};

export const suggested: CSSProperties = {
  marginLeft: "15px",
  fontSize: "13px",
};

export const userImg: CSSProperties = {
  width: 30,
  height: 30,
  marginRight: 10,
  display: "inline-block",
};

export const tooltipIcon: CSSProperties = {
  color: palette.cloudyBlue,
  top: "1px",
};

export const tooltipContent: CSSProperties = {
  color: greys.white,
};

export const name: CSSProperties = {
  color: greys.dark,
};

export const email: CSSProperties = {
  fontSize: typeStyles.size.md,
  color: greys.slate,
};

export const avatar: CSSProperties = {
  position: "relative",
};

export const badge: CSSProperties = {
  position: "absolute",
  backgroundColor: colors.blueCool.standard,
  borderRadius: "50%",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  zIndex: 2,
};
